<template>
  <div class="app-container">
    <!-- <el-tabs v-model="activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="全部" name="all" />
      <el-tab-pane label="待处理" name="pending" />
      <el-tab-pane label="已完成" name="success" />
      <el-tab-pane label="失败" name="failed" />
    </el-tabs>

    <div class="summary-bar">
      <div class="summary-item">
        <span class="label">今日提现总额</span>
        <span class="value">¥ {{ summary.todayTotalAmount | amountFormatter }}</span>
      </div>
      <div class="summary-item">
        <span class="label">待处理提现</span>
        <span class="value">{{ summary.pendingCount }} 笔</span>
      </div>
      <div class="summary-item">
        <span class="label">已完成提现</span>
        <span class="value">{{ summary.completedCount }} 笔</span>
      </div>
    </div> -->

    <div class="search-bar">
      <el-form :inline="true" :model="searchParams" @submit.native.prevent>
        <el-form-item>
          <el-input v-model="searchParams.user_id" placeholder="用户编号" clearable @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
          <el-button icon="el-icon-refresh" @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="data-table">
      <el-table :data="records" border fit highlight-current-row style="width: 100%" v-loading="loading">
        <el-table-column type="index" width="60" label="#" align="center" />
        <el-table-column prop="order_id" label="提现单号" width="220" align="center" />
        <el-table-column prop="user_id" label="用户编号" width="120" align="center" />
        <el-table-column prop="amount" label="提现金额" width="120" align="center">
          <template slot-scope="{ row }">
            <span>{{ formatAmount(row.amount) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="statusTagType(row.status)" size="small">{{ statusText(row.status) }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="wechat_order_id" label="微信单号" width="240" align="center" />
        <el-table-column prop="created_at" label="申请时间" width="170" align="center" />
        <el-table-column prop="processed_at" label="处理时间" width="170" align="center" />
        <el-table-column prop="updated_at" label="更新时间" width="170" align="center" />
      </el-table>
    </div>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="searchParams.page"
        :page-size="searchParams.page_size"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
import { getWithdrawRecords } from '@/api/finances'

export default {
  name: 'WithdrawRecords',
  filters: {
    amountFormatter(val) {
      const num = Number(val)
      if (isNaN(num)) return val
      return num.toFixed(2)
    }
  },
  data() {
    return {
      loading: false,
      activeTab: 'all',
      searchParams: {
        user_id: '',
        page: 1,
        page_size: 10,
        status: ''
      },
      total: 0,
      records: [],
      summary: {
        todayTotalAmount: 12345.67, // Mock data
        pendingCount: 12, // Mock data
        completedCount: 123 // Mock data
      }
    }
  },
  created() {
    this.fetchRecords()
  },
  methods: {
    async fetchRecords() {
      this.loading = true
      try {
        const params = { ...this.searchParams, type: 'personal' }
        if (params.status === 'all') {
          params.status = ''
        }

        const res = await getWithdrawRecords(params)
        if (res) {
          const list = Array.isArray(res.data)
            ? res.data
            : (res.data && (res.data.list || res.data.records || res.data.withdraw_records)) || []
          const total = res.total != null
            ? res.total
            : (res.data && (res.data.total || res.data.count)) || 0
          const page = res.page != null ? res.page : this.searchParams.page
          const page_size = res.page_size != null ? res.page_size : this.searchParams.page_size
          this.records = Array.isArray(list) ? list : []
          this.total = Number(total) || 0
          this.searchParams.page = Number(page) || this.searchParams.page
          this.searchParams.page_size = Number(page_size) || this.searchParams.page_size
        } else {
          this.records = []
          this.total = 0
        }
      } catch (e) {
        this.$message.error('获取提现记录失败')
      } finally {
        this.loading = false
      }
    },
    handleTabClick(tab) {
      this.searchParams.status = tab.name
      this.searchParams.page = 1
      this.fetchRecords()
    },
    handleSearch() {
      this.searchParams.page = 1
      this.fetchRecords()
    },
    handleReset() {
      this.searchParams = { user_id: '', page: 1, page_size: 10, status: this.activeTab }
      this.fetchRecords()
    },
    handleSizeChange(size) {
      this.searchParams.page_size = size
      this.fetchRecords()
    },
    handleCurrentChange(current) {
      this.searchParams.page = current
      this.fetchRecords()
    },
    statusText(status) {
      const mapStr = { pending: '处理中', processing: '处理中', success: '已完成', failed: '失败' }
      const mapNum = { 1: '待处理', 2: '处理中', 3: '已完成', 4: '失败' }
      if (typeof status === 'number') return mapNum[status] || String(status)
      return mapStr[status] || (status || '')
    },
    statusTagType(status) {
      const mapStr = { pending: 'warning', processing: 'warning', success: 'success', failed: 'danger' }
      const mapNum = { 1: 'info', 2: 'warning', 3: 'success', 4: 'danger' }
      if (typeof status === 'number') return mapNum[status] || 'info'
      return mapStr[status] || 'info'
    },
    formatAmount(val) {
      const num = Number(val)
      if (isNaN(num)) return val
      return `¥ ${num.toFixed(2)}`
    },
    viewDetail(row) {
      this.$alert(`<pre>${JSON.stringify(row, null, 2)}</pre>`, '提现详情', {
        dangerouslyUseHTMLString: true,
        confirmButtonText: '关闭'
      })
    }
  }
}
</script>

<style scoped>
.app-container {
  padding: 20px;
  background-color: #f0f2f5;
}

.summary-bar {
  display: flex;
  justify-content: space-around;
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.summary-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.summary-item .label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
}

.summary-item .value {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
}

.search-bar {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
}

.data-table {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
}

.pagination-wrapper {
  background-color: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-top: 20px;
  text-align: right;
}

::v-deep .el-tabs__header {
  margin-bottom: 0;
  background-color: #fff;
  padding: 0 20px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

::v-deep .el-tabs__nav-wrap::after {
  display: none;
}

::v-deep .el-form-item {
  margin-bottom: 0;
}
</style>
